import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const lessonApi = createApi({
    reducerPath: "lessonApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["lesson"],
    endpoints: (builder) => ({
        getLesson: builder.query({
            query: ({ pageno, course, disablePagination }) => {
                let url = `/admin/lessons/${course}?pageno=${pageno}`;
                if (disablePagination) {
                    url += `&disablePagination=true`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["course"],
        }),
        getSingleLesson: builder.query({
            query: ({ id }) => {
                let url = `/admin/lesson/${id}`;
                return { url, method: "GET"}
            },
            providesTags: ["lesson"],
        }),
        addLesson: builder.mutation({
            query: (data) => ({
                url: `/admin/lesson`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["lesson"],
        }),
        updateLesson: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/lesson/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["lesson"],
        }),
        getDetailLesson: builder.query({
           query: ({ id }) => {
              let url = `/admin/lesson/detail/${id}`;
              return { url, method: "GET"}
            },
          providesTags: ["lesson"],
        }),
        markedLessonCompleted: builder.mutation({
          query: (id) => ({
                url: `/contractor/lesson/${id}/toggle`,
                method: "POST",
            }),
            invalidatesTags: ["lesson"],
        }),
        getHomeLessonDetail: builder.query({
          query: ({ id }) => {
             let url = `/contractor/lesson/${id}`;
             return { url, method: "GET"}
            },
          providesTags: ["lesson"],
        }),
        downloadLessonResource: builder.query({
          query: ({ id, resourceId }) => {
             let url = `/contractor/lesson/${id}/resource/${resourceId}/download`;
             return { url, method: "GET"}
            },
        }),
        updateReorderLesson: builder.mutation({
            query: (data) => ({
                url: `/admin/lesson/reorder/${data.courseId}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["lesson"],
        }),
    }),
});

export const {
    useGetLessonQuery,
    useAddLessonMutation,
    useUpdateLessonMutation,
    useGetSingleLessonQuery,
    useGetDetailLessonQuery,
    useMarkedLessonCompletedMutation,
    useGetHomeLessonDetailQuery,
    useLazyDownloadLessonResourceQuery,
    useUpdateReorderLessonMutation,
} = lessonApi;